const PropTypes = require('prop-types');
const React = require('react');
const reactUpdate = require('react-addons-update');
const ProductDetails = require('./product_details.jsx');
const PriceFieldWithCurrency = require('../shared/price_field_with_currency.jsx');
const Tooltip = require('../tooltip.jsx');

class BundleInfoForm extends React.Component {
  static propTypes = {
    bundledProduct: PropTypes.object.isRequired,
    remove: PropTypes.func.isRequired,
    userCurrency: PropTypes.string.isRequired,
    errorMessage: PropTypes.string,
    index: PropTypes.number.isRequired,
  };

  errorMessage = () => {
    if (this.props.bundledProduct.errorMessage) {
      return <p className="alert alert-error">{this.props.bundledProduct.errorMessage}</p>;
    }
  };

  priceChanged = (e) => {
    const price = e.target.value;

    const newBundledProductListing = reactUpdate(this.props.bundledProduct.listing, { $merge: { price: { amount: price, symbol: this.props.bundledProduct.listing.original_price.symbol } } });
    this.props.bundledProduct.listing = newBundledProductListing;
    this.props.bundledProductChanged(this.props.bundledProduct, this.props.index);
  };

  freeShippingChanged = (e) => {
    const freeShipping = e.target.checked;
    const newBundledProduct = reactUpdate(this.props.bundledProduct, { $merge: { free_shipping: freeShipping } });

    this.props.bundledProductChanged(newBundledProduct, this.props.index);
  };

  idField = () => {
    if (this.props.bundledProduct.id) {
      return <input type="hidden" value={this.props.bundledProduct.id} name={`product_bundle[bundled_products_attributes][${this.props.index}][id]`} />;
    }
  };

  render() {
    return (
      <div className="module bd-rounded bundle-form mb-1">
        <div className="g-container">
          <div className="g-col-6">
            <h4 className="heading-3 mb-half">{I18n.t('js.productBundles.bundleInfoForm.bundledListing')}</h4>
          </div>
          <div className="g-col-6 align-right">
            <Tooltip title={I18n.t('js.productBundles.bundleInfoForm.removeAddOn')}>
              <a onClick={() => { this.props.remove(this.props.index); }}><span className="fa fa-times" /></a>
            </Tooltip>
          </div>
        </div>
        {this.errorMessage()}
        {this.idField()}
        <input type="hidden" value={this.props.bundledProduct.listing.id} name={`product_bundle[bundled_products_attributes][${this.props.index}][listing_id]`} />
        <ProductDetails product={this.props.bundledProduct.listing} newPrice={(this.props.bundledProduct.listing.price && this.props.bundledProduct.listing.price.amount) || 0} originalPrice={this.props.bundledProduct.listing.original_price} />
        <hr className="mtb-1" />
        <div className="g-container">
          <div className="g-col-3">
            <label htmlFor="price">{I18n.t('js.productBundles.bundleInfoForm.priceLabel')} <Tooltip className="muted" title={I18n.t('js.productBundles.bundleInfoForm.priceLabelTooltip')} /></label>
            <PriceFieldWithCurrency
              currency={this.props.userCurrency}
              name={`product_bundle[bundled_products_attributes][${this.props.index}][price]`}
              value={this.props.bundledProduct.listing.price && this.props.bundledProduct.listing.price.amount}
              onChange={this.priceChanged}
            />
          </div>
          <div className="g-col-1" />
          <div className="g-col-8">
            <label>{I18n.t('js.productBundles.bundleInfoForm.shippingLabel')} <Tooltip className="muted" title={I18n.t('js.productBundles.bundleInfoForm.shippingLabelTooltip')} /></label>
            <label className="normal mb-0 checkbox">
              <input type="hidden" name={`product_bundle[bundled_products_attributes][${this.props.index}][free_shipping]`} value="0" />
              <input type="checkbox" name={`product_bundle[bundled_products_attributes][${this.props.index}][free_shipping]`} checked={this.props.bundledProduct.free_shipping} onChange={this.freeShippingChanged} /> {I18n.t('js.productBundles.bundleInfoForm.freeShipping')}
            </label>
          </div>
        </div>
      </div>
    );
  }
}

module.exports = BundleInfoForm;



// WEBPACK FOOTER //
// ./javascripts/components/product_bundles/bundle_info_form.jsx